module.exports = function() {
  return new Worker(__webpack_public_path__ + "b6bc9713c9467f11fbf3.worker.js");
};